export const JOBS_CONTACT_EMAIL: string = 'rekrytointi@tukiluotsi.fi';

export const contacts = [
  {
    name: 'Marko Tolska',
    roleKey: 'chiefExecutiveOfficer', //Toimitusjohtaja
    phone: '050 537 3168',
    email: 'marko.tolska@tukiluotsi.fi',
  },
  {
    name: 'Tiia-Tuulia Peltola',
    roleKey: 'directorOfServices', //Palvelujohtaja
    phone: '050 541 7963',
    email: 'tiia-tuulia.peltola@tukiluotsi.fi',
  }
];

export const businessInfo = {
  name: 'Tukiluotsi Oy',
  address: 'Petikontie 1, 01720 Vantaa',
  yTunnus: 'Y-3467004-5',
  email: 'tukiluotsi@tukiluotsi.fi',
};